var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',[_c('div',{staticClass:"text-center py-10"},[_c('h3',{staticClass:"text-6xl text-black text-opacity-75",domProps:{"textContent":_vm._s(_vm.value)}}),_c('h5',{staticClass:"text-black text-opacity-75 capitalize",domProps:{"textContent":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }